import { Box, Grid, Typography, TextField } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Settings } from './i18n';
import { useUserData } from '../../hooks/auths/useUserData';

export const ProfileSettings = () => {
  const { t } = useTranslation(Settings);
  const { name, email, lastName } = useUserData();
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
  });

  const handleChange =
    (field: keyof typeof formData) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setFormData((prev) => ({
        ...prev,
        [field]: event.target.value,
      }));
    };

  return (
    <Box>
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontSize: '24px',
        }}
      >
        {t('profileSettings.title')}
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h4" gutterBottom sx={{ marginTop: '32px' }}>
            {t('profileSettings.userDetails')}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" gutterBottom color="textSecondary">
            {t('profileSettings.fullName')}
          </Typography>
          <TextField
            fullWidth
            size="small"
            value={`${name} ${lastName}`}
            onChange={handleChange('fullName')}
            variant="outlined"
            disabled
          />
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" gutterBottom color="textSecondary">
            {t('profileSettings.email')}
          </Typography>
          <TextField
            fullWidth
            size="small"
            value={email}
            onChange={handleChange('email')}
            variant="outlined"
            disabled
          />
        </Grid>
      </Grid>
    </Box>
  );
};
